// extracted by mini-css-extract-plugin
export default {"rating":"pK-z","numberOfStars":"qK-z","count":"rK-z","barGraphSpacing":"sK-z","barGraph":"tK-z"};